import axios from "axios";
import { showAlert } from "./alert";

export const sendCarrier = async (
  contactName,
  contactEmail,
  contactMessage
) => {
  try {
    const res = await axios({
      method: "POST",
      url: "/api/v1/users/sendCarrier",
      data: {
        contactName,
        contactEmail,
        contactMessage,
      },
    });

    if (res.data.status === "success") {
      showAlert("success", "Message Recieved!");
      window.setTimeout(() => {
        location.reload();
      }, 1500);
    }
  } catch (error) {
    console.log(error);
    showAlert("error", "Error sending message. Try again.");
  }
};
